import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../../../../../parts/modal-new";
import TemplateSelectionList from "../components/TemplateSelectionList";

const ReplaceDayFromTemplateModal = ({ locals }) => {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const { mealPlanTemplates = [], query } = locals;
  const { date, athlete, mealPlan: mealPlanId, week = 1, hasFoods } = query;
  const isEmpty = !(hasFoods === "true" || hasFoods === true);

  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  /**
   * Handle template selection
   */
  const handleTemplateSelect = (templateId) => {
    setSelectedTemplateId(templateId);
  };

  /**
   * Handle save
   */
  const handleSave = () => {
    if (!selectedTemplateId) return;

    if (!mealPlanId) {
      console.error("mealPlanId is required");
      return;
    }

    if (!date) {
      console.error("Invalid date");
      return;
    }

    const isTemplate = !athlete;
    const dateToUse = isTemplate ? `Week ${week} ${date}` : date;

    const body = {
      templateId: selectedTemplateId,
      date: dateToUse,
      isTemplate,
    };

    submit(
      `/actions/meal-planner/replace-day-from-template?mealPlanId=${mealPlanId}&proxyAthlete=${athlete || ""}`,
      {
        method: "POST",
        body,
      }
    );
  };

  return (
    <Modal
      className="replace-option-from-template"
      title={t(
        isEmpty
          ? "athlete-portal:replaceDayFromTemplateModal.titleEmpty"
          : "athlete-portal:replaceDayFromTemplateModal.title"
      )}
      toClear={[]}
    >
      <div className="body">
        {mealPlanTemplates.length > 0 && (
          <div className="description">
            <span>
              {t("athlete-portal:replaceDayFromTemplateModal.description")}
            </span>
          </div>
        )}
        <TemplateSelectionList
          templates={mealPlanTemplates}
          selectedTemplateId={selectedTemplateId}
          onSelect={handleTemplateSelect}
          onSave={handleSave}
          emptyStateTitleKey="athlete-portal:replaceDayFromTemplateModal.noTemplatesTitle"
          emptyStateDescriptionKey="athlete-portal:replaceDayFromTemplateModal.noTemplatesDescription"
        />
      </div>
    </Modal>
  );
};

ReplaceDayFromTemplateModal.propTypes = {
  locals: PropTypes.object,
};

export default ReplaceDayFromTemplateModal;
